import React, { useEffect, useState } from 'react';
import styles from './index.module.css';

import { v4 as uuidv4 } from 'uuid';

import { useImmer } from 'use-immer';
import { Keypair, PublicKey, SystemProgram, Transaction } from '@solana/web3.js';

const makePoll = (topic, desc = '', author = 'admin') => {
	const uid = uuidv4();
	return {
		id: uid,
		topic,
		desc,
		author: '',
		yes: [],
		no: [],
	};
};

const VotingPage = () => {
	var tmp = 0;
	const [polls, setPolls] = useImmer([]);

	const add = () => {
		const polltopic = prompt('Input your poll topic');
		console.log(polltopic);
		if (!polltopic || polltopic === '') {
			alert('No');
			return;
		}

		const poll = makePoll(polltopic);

		const transaction = new Transaction();

		const splacc = Keypair.generate();

		const programId = new PublicKey('AmLHxnyrJBMnYWVzezw1kpoXQ6JQgfrB1kbBDCacwGFn');

		// transaction function not fully done, should stores poll info on blockchain
		const instruction = SystemProgram.createAccount({
			fromPubkey:'',
			newAccountPubkey:splacc.publicKey,
			space: 165,
			data:poll,
			programId,
		})

		setPolls((prev) => [...prev, poll]);
	};

	const vote = (id, ch) => {
		setPolls((prev) => {
			if (ch == 0) {
				// vote against
				console.log('against');
				const poll = prev.find((item) => item.id === id);
				prev = prev.filter((item) => item.id === id);

				poll.no.push(tmp++);
				prev.push(poll);
			} else {
				console.log('for');
				const poll = prev.find((item) => item.id === id);
				prev = prev.filter((item) => item.id !== id);

				poll.yes.push(tmp++);

				prev.push(poll);
			}
		});
	};

	useEffect(() => {}, []);
	return (
		<div className={styles.container}>
			<h2>Dashboard</h2>

			<div className={styles.top}>
				<div>
					<p>Welcome user!</p>
					<h3>Your Statistics</h3>
				</div>

				<div>FUTURE STATS</div>
			</div>

			<div className={styles.pollscont}>
				<h2>Polls</h2>
				{polls.length > 0 ? (
					<div>
						<div className={styles.pollheader}>
							<h3>Current Polls</h3>{' '}
							<button
								className={styles.btn}
								onClick={() => add()}
							>
								Add Poll
							</button>
						</div>

						<div className={styles.polls}>
							{polls.map((poll) => {
								console.log(poll);

								return (
									<div key={poll.id} className={styles.poll}>
										<h3>Do you want to vote for below</h3>
										<code>{poll.topic}</code>

										<div className={styles.pollsbtns}>
											<button
												onClick={() => {
													vote(poll.id, 1);
												}}
												className={
													styles.btn +
													' ' +
													styles.for
												}
											>
												For {poll.yes.length}
											</button>
											<button
												onClick={() => {
													vote(poll.id, 0);
												}}
												className={
													styles.btn +
													' ' +
													styles.against
												}
											>
												Against {poll.no.length}
											</button>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				) : (
					<div>
						<h3>No Polls?</h3>
						<button className={styles.btn} onClick={() => add()}>
							Add Poll
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default VotingPage;
